import type { IconName } from "../../icons";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  icon?: IconName;
  /** Small colored dot (priority, label color). Any CSS color, including `var(--…)`. */
  color?: string;
  /** Initials shown in a round avatar (people). */
  avatar?: string;
  /** Secondary text at the right of the option. */
  hint?: string;
}

/** Shaped like a change event so `onChange={(e) => set(e.target.value)}` keeps working. */
export interface SelectChangeEvent {
  target: { value: string; name: string };
  currentTarget: { value: string; name: string };
}

/** DOM id of the option at `index` of the listbox `listId`, for `aria-activedescendant`. */
export function optionId(listId: string, index: number): string {
  return `${listId}-o${index}`;
}
